function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { positiveQuantityInputProps } from "../../../constants";
export default function PriceTextField() {
  const {
    control,
    watch
  } = useFormContext();
  const pricing = watch('pricing');
  const label = pricing === 'fixed' ? 'Rate' : pricing === 'range' ? 'Max price' : "Rate per ".concat(pricing === 'hour' ? 'hour' : 'unit');
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "price",
    rules: {
      validate: val => val && +val >= 0 || 'Insert a non-negative price'
    },
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({
      isMoney: true,
      alwaysShrinkLabel: true,
      inputProps: positiveQuantityInputProps,
      label: label,
      prefix: "$",
      "data-testid": "sb-price"
    }, connectControllerToTextField(renderProps)))
  });
}